// extracted by mini-css-extract-plugin
export default {"loaderSpan":"Loader_loaderSpan__01TlG","loaderSpanAnimation":"Loader_loaderSpanAnimation__EYGTo","spin":"Loader_spin__8TnK+","loaderSpanText":"Loader_loaderSpanText__ZfbPh"};